import { ACPCustomEvents } from './../events';

export class BusinessContextDataUpdatedEvent extends CustomEvent<void> {
  constructor() {
    super(ACPCustomEvents.BusinessContextDataUpdated);
  }
}
